<template>
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="13.3333"
      height="13.3333"
      rx="6.66667"
      transform="matrix(1 0 0 -1 1.33325 15.1665)"
      fill="currentColor"
    />
    <path
      d="M7.93289 6.79385C8.37472 6.79385 8.73289 6.43568 8.73289 5.99385C8.73289 5.55202 8.37472 5.19385 7.93289 5.19385C7.49107 5.19385 7.13289 5.55202 7.13289 5.99385C7.13289 6.43568 7.49107 6.79385 7.93289 6.79385Z"
      fill="white"
    />
    <path
      d="M6.99956 7.45394C6.8891 7.45394 6.79956 7.54348 6.79956 7.65394V8.05394C6.79956 8.1644 6.8891 8.25394 6.99956 8.25394H7.33394C7.44439 8.25394 7.53394 8.34348 7.53394 8.45394V10.8957H6.86675C6.75629 10.8957 6.66675 10.9852 6.66675 11.0957V11.4957C6.66675 11.6061 6.75629 11.6957 6.86675 11.6957H9.13341C9.24387 11.6957 9.33341 11.6061 9.33341 11.4957V11.0957C9.33341 10.9852 9.24387 10.8957 9.13341 10.8957H8.73394V7.65394C8.73394 7.54348 8.64439 7.45394 8.53394 7.45394H6.99956Z"
      fill="white"
    />
  </svg>
</template>
